import React, { FC } from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'
import { RiskScoreRules } from './RiskScoreRules'
import { CreateRule } from './CreateRule'
import { RuleDetails } from './RuleDetails/RuleDetails'
import { EditRule } from './EditRule/EditRule'

export const RiskScoreRoutes: FC = () => {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path} component={RiskScoreRules} />
      <Route exact path={`${path}/create`} component={CreateRule} />
      <Route exact path={`${path}/:id/details`} component={RuleDetails} />
      <Route exact path={`${path}/:id/edit`} component={EditRule} />
      {/*
      <Route exact path={`${path}/:id/delete`} component={DeleteRule} />
      */}
    </Switch>
  )
}
